import React from 'react';
import { getProcessStatus, getProcessStatusClass, getProcessDotClass } from '../../utils/processStatus';
import './ProcessStatus.css';

/**
 * ProcessStatus Component
 * 
 * Minimal process compliance indicator
 * Shows: [dot] Process: X%
 */
const ProcessStatus = ({ application, showMessage = false, compact = false }) => {
  if (!application) return null;

  const process = getProcessStatus(application);
  const statusClass = getProcessStatusClass(process.status);
  const dotClass = getProcessDotClass(process.status);

  if (compact) {
    // Compact version - just the dot and percentage
    return (
      <span className={statusClass}>
        <span className={dotClass}></span>
        {process.score}%
      </span>
    );
  }

  return (
    <span className={statusClass}>
      <span className={dotClass}></span>
      Process: {process.score}%
      {showMessage && process.status === 'pending' && (
        <span className="process-message"> • {process.message}</span>
      )}
    </span>
  );
};

export default ProcessStatus;


